export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type Sorting = {
  field: string;
  sortOrder: SortOrder;
};
